export const state = {
    visible: false,
    current: null
};



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/state.js